import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sm:flex gap-2 sm:gap-4 mt-4 sm:mt-6" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "h-fit w-full sm:mt-0 mt-6" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center gap-2 ml-auto rounded-md bg-gray-700 px-4 py-2 max-w-fit mb-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "redirect-label",
  class: "text-white text-ellipsis whitespace-nowrap overflow-hidden"
}, "Redirect Mode", -1)
const _hoisted_6 = { class: "flex gap-2 sm:gap-4 max-w-fit ml-auto" }

import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import { Input, TreeSelect, Button, Form } from 'ant-design-vue';
import { CopyOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons-vue';
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import { JAV } from '@/model/jav';
import LocalStorageKey from '@/model/key';
import { scrapingJAV } from '@/util/scraping';


export default /*#__PURE__*/_defineComponent({
  __name: 'JAVInformation',
  props: {
    jav: {},
    isLoading: { type: Boolean },
    mode: {}
  },
  emits: ["submit", "reset"],
  setup(__props: any, { emit }) {

const props = __props;




const _isLoading = ref(props.isLoading);
const isRedirect = ref(localStorage.getItem(LocalStorageKey.JAVRedirect) === 'on');
const imageBlobURL = ref('');
const reload = ref(false);
const fileInput = ref<HTMLInputElement>();
const javData = ref<JAV>({ ...props.jav });
const actress = ref('');
const genre = ref('');
const store = useStore();

watch(isRedirect, () =>
	localStorage.setItem(LocalStorageKey.JAVRedirect, isRedirect.value ? 'on' : 'off')
);
watch(
	() => props.isLoading,
	() => (_isLoading.value = props.isLoading)
);
watch(
	() => props.jav,
	() => {
		javData.value = { ...props.jav };
		resetFileInput();
	}
);

const submit = async () => {
	if (!_isLoading.value && !reload.value) {
		await emit('submit', isRedirect.value, javData.value);
	} else {
		store.dispatch('alert', { type: 'warning', message: 'please wait for any progress!' });
	}
};
const reset = () => {
	resetFileInput();
	emit('reset');
};

async function resetFileInput() {
	if (fileInput.value) {
		reload.value = true;
		fileInput.value.src = props.jav.coverImageURL;
		imageBlobURL.value = props.jav.coverImageURL;
		reload.value = false;
	}
}

function mapSelect(texts: string[]) {
	return texts.map((text) => {
		return {
			value: text,
			title: text,
			label: text,
			key: text
		};
	});
}

async function scraping() {
	if (!javData.value.link) {
		return;
	}
	try {
		_isLoading.value = true;
		const jav = await scrapingJAV(javData.value.link);
		javData.value.actresses = jav.actresses;
		javData.value.code = jav.code;
		javData.value.coverImageURL = jav.coverImageURL;
		javData.value.genres = jav.genres;
		javData.value.link = jav.link;
		javData.value.title = jav.title;
		imageBlobURL.value = javData.value.coverImageURL;
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		_isLoading.value = false;
	}
}

function changeImage(e: Event) {
	const fileInput = e.target as HTMLInputElement;
	if (fileInput?.files?.length === 1) {
		reload.value = true;
		imageBlobURL.value = URL.createObjectURL(fileInput.files[0]);
		reload.value = false;
	}
}

function addActress() {
	if (actress.value.trim() && !javData.value.actresses.includes(actress.value.trim())) {
		javData.value.actresses.push(actress.value.trim());
		actress.value = '';
	}
}

function addGenre() {
	if (genre.value.trim() && !javData.value.genres.includes(genre.value.trim())) {
		javData.value.genres.push(genre.value.trim());
		genre.value = '';
	}
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createBlock(SpinnerLoading, { loading: _isLoading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ImageLoading, {
            src: imageBlobURL.value,
            reload: reload.value,
            previewable: true,
            "img-class": "!h-72 !w-72",
            "loading-class": "h-72 w-72 m-auto sm:m-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                onClick: _cache[0] || (_cache[0] = () => fileInput.value?.click()),
                class: "sm:hidden my-4 rounded-full absolute left-1/2 translate-x-32 translate-y-[15.5rem]"
              }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(UploadOutlined))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["src", "reload"]),
          _createElementVNode("input", {
            type: "file",
            ref_key: "fileInput",
            ref: fileInput,
            accept: "image/*",
            hidden: "",
            onChange: changeImage
          }, null, 544)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Form), {
            layout: "horizontal",
            model: javData.value,
            onFinish: _cache[12] || (_cache[12] = ($event: any) => (submit()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Form).Item, {
                label: "Link",
                name: "link",
                "has-feedback": "",
                rules: [{ required: true, message: 'Please input jav link' }],
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input).Group, { compact: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Input), {
                        value: javData.value.link,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((javData.value.link) = $event)),
                        class: "!w-[calc(100%-2rem)] !text-start",
                        placeholder: "Enter jav link that start with `https://missav.ws/en/{code}`"
                      }, null, 8, ["value"]),
                      _createVNode(_unref(Button), { onClick: scraping }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(CopyOutlined))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Form).Item, {
                label: "Cover Image URL",
                name: "coverImageURL",
                "has-feedback": "",
                rules: [{ required: true, message: 'Please input jav cover image url' }],
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input).Group, { compact: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Input), {
                        value: javData.value.coverImageURL,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((javData.value.coverImageURL) = $event)),
                        class: "!w-[calc(100%-2rem)] !text-start",
                        placeholder: "Enter jav cover image url that start with `https://fivetiu.com/{code}/cover-n.jpg`"
                      }, null, 8, ["value"]),
                      _createVNode(_unref(Button), {
                        onClick: _cache[3] || (_cache[3] = () => (imageBlobURL.value = javData.value.coverImageURL))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(CopyOutlined))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Form).Item, {
                label: "Title",
                name: "title",
                "has-feedback": "",
                rules: [{ required: true, message: 'Please input jav title' }],
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input), {
                    value: javData.value.title,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((javData.value.title) = $event)),
                    placeholder: "Enter jav title"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Form).Item, {
                label: "Code",
                name: "code",
                "has-feedback": "",
                rules: [{ required: true, message: 'Please input jav code' }],
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input), {
                    value: javData.value.code,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((javData.value.code) = $event)),
                    placeholder: "Enter jav code"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Form).Item, {
                label: "Actresses",
                name: "actresses",
                rules: [{ required: true }],
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input).Group, { compact: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Input), {
                        value: actress.value,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((actress).value = $event)),
                        class: "!w-[calc(100%-2rem)] !text-start",
                        placeholder: "Enter jav actress name",
                        onPressEnter: addActress
                      }, null, 8, ["value"]),
                      _createVNode(_unref(Button), { onClick: addActress }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(PlusOutlined))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(TreeSelect), {
                    value: javData.value.actresses,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((javData.value.actresses) = $event)),
                    style: {"width":"100%"},
                    "tree-data": mapSelect(javData.value.actresses),
                    "tree-checkable": "",
                    class: "text-start mt-6",
                    placeholder: "Please select jav artists",
                    "tree-node-filter-prop": "label"
                  }, null, 8, ["value", "tree-data"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Form).Item, {
                label: "Genres",
                name: "genres",
                rules: [{ required: true }],
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input).Group, { compact: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Input), {
                        value: genre.value,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((genre).value = $event)),
                        class: "!w-[calc(100%-2rem)] !text-start",
                        placeholder: "Enter jav genre",
                        onPressEnter: addGenre
                      }, null, 8, ["value"]),
                      _createVNode(_unref(Button), { onClick: addGenre }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(PlusOutlined))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(TreeSelect), {
                    value: javData.value.genres,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((javData.value.genres) = $event)),
                    style: {"width":"100%"},
                    "tree-data": mapSelect(javData.value.genres),
                    "tree-checkable": "",
                    class: "text-start mt-6",
                    placeholder: "Please select jav genres",
                    "tree-node-filter-prop": "label"
                  }, null, 8, ["value", "tree-data"])
                ]),
                _: 1
              }),
              (_ctx.mode === 'CREATE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_a_switch, {
                      checked: isRedirect.value,
                      "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((isRedirect).value = $event))
                    }, null, 8, ["checked"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Button), {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (reset()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Reset")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  "html-type": "submit",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})